import { type FC, memo, useEffect } from 'react';
import WalletConnected from './wallet-connected';
import WalletUnconnect from './wallet-unconnect';
import WalletDialog from './wallet-dialog';
import { useInitBalances } from '@hooks/use-balance';
import { useAddress } from '@hooks/use-address';
import { formatAddress } from '@mysten/sui/utils';
import { useCurrentWallet } from '@mysten/dapp-kit';
import { notification } from 'antd';

const ConnectWallet: FC = () => {
  const wallet = useCurrentWallet();
  const address = useAddress();
  useInitBalances();

  useEffect(() => {
    if (wallet.isConnected && wallet.currentWallet && address) {
      notification.open({
        message: `${wallet.currentWallet.name} wallet connected`,
        description: `${formatAddress(address)}`,
      });
    }
  }, [wallet.isConnected, address]);

  return (
    <>
      {address ? <WalletConnected /> : <WalletUnconnect />}
      <WalletDialog />
    </>
  );
};

export default memo(ConnectWallet);
